import React, { useState, useEffect, useCallback } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function Menu() {
    const [userData, setUserData] = useState(null);
    const [loadincount, setloadincount] = useState(true);
    const [username, setusername] = useState("");
    const [role, setrole] = useState("");

    // State for the Reports submenu (original state, kept for consistency)
    const [isOpen, setIsOpen] = useState(false);
    // State for Reservations submenu (new state)
    const [isReservationsOpen, setIsReservationsOpen] = useState(false);
    // State for Admin submenu (new state)
    const [isAdminOpen, setIsAdminOpen] = useState(false); 

    // Toggle function for the Reports submenu
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    
    // Toggle function for the Reservations submenu
    const toggleReservations = () => {
        setIsReservationsOpen(!isReservationsOpen);
    };

    // Toggle function for the Admin submenu
    const toggleAdmin = () => {
        setIsAdminOpen(!isAdminOpen);
    };

    // --- Data Fetching Logic (Corrected for proper cleanup) ---

    const fetchUserData = useCallback(async (uid) => {
        try {
            if (loadincount) {
                const docRef = doc(db, "users", uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setrole(docSnap.data().role || "User");
                    setusername(docSnap.data().username || "Guest");
                    setloadincount(false);
                }
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    }, [loadincount]);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
            if (user) {
                fetchUserData(user.uid);
            }
        });

        return () => unsubscribe(); // Proper cleanup of the auth listener
    }, [fetchUserData]);

    // --- Render Content ---

    return (
        <div>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                {/* Brand Logo */}
                <a href="/home" className="brand-link">
                    <img 
                        src={window.location.origin + '/user.jpg'} 
                        alt="User" 
                        className="brand-image img-circle elevation-3" 
                        style={{ opacity: '.8' }} 
                    />
                    <span className="brand-text font-weight-light">{username} </span>
                </a>
                
                <div className="sidebar">
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            
                            {/* Home */}
                            <li className="nav-item">
                                <a href="/home" className="nav-link">
                                    <i className="nav-icon fa fa-home" />
                                    <p>Home</p>
                                </a>
                            </li>

                            {/* Approvals */}
                            <li className="nav-item">
                                <a href="/approvals" className="nav-link">
                                    <i className="nav-icon fa fa-check-circle" />
                                    <p>Approvals</p>
                                </a>
                            </li>
                            
                            {/* -------------------- Reservations Submenu -------------------- */}
                            <li className="nav-header" style={{ fontWeight: "700" }}>RESERVATIONS</li>
                            <li 
                                className={`nav-item ${isReservationsOpen ? 'menu-open' : ''}`}
                            >
                                <a 
                                    href="#0" 
                                    className={`nav-link ${isReservationsOpen ? 'active' : ''}`}
                                    onClick={toggleReservations}
                                >
                                    <i className="nav-icon fa fa-book" />
                                    <p>
                                        Reservations
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <a href="/live-bookings" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>Live Bookings</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/checkout-history" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>Checkout History</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/pending-bookings" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>Pending Bookings</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/damage-notes" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>Damage Notes</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>


                            {/* -------------------- Reports Submenu (FIXED) -------------------- */}
                            <li className="nav-header" style={{ fontWeight: "700" }}>REPORTS</li>
                            <li 
                                className={`nav-item ${isOpen ? 'menu-open' : ''}`}
                            >
                                <a 
                                    href="#0" 
                                    className={`nav-link ${isOpen ? 'active' : ''}`}
                                    onClick={toggleDropdown}
                                >
                                    <i className="nav-icon fa fa-bar-chart" />
                                    <p>
                                        View Reports
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <a href="/room-type-wise-online-bookings" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>Room Type Wise Online </p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/receptionist-report" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>Receptionist Report</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/all-booking-report" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>All Booking Report</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/paymode-wise-report" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>Payment Mode Wise</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/booking-type-report" className="nav-link">
                                            <i className="fa fa-circle nav-icon" />
                                            <p>Booking Type Wise</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            
                            {/* -------------------- Admin/Settings Submenu -------------------- */}
                            {role === 'Admin' && (
                                <>
                                    <li className="nav-header" style={{ fontWeight: "700" }}>ADMINISTRATION</li>
                                    <li 
                                        className={`nav-item ${isAdminOpen ? 'menu-open' : ''}`}
                                    >
                                        <a 
                                            href="#0" 
                                            className={`nav-link ${isAdminOpen ? 'active' : ''}`}
                                            onClick={toggleAdmin}
                                        >
                                            <i className="nav-icon fa fa-cogs" />
                                            <p>
                                                Settings & Users
                                                <i className="right fa fa-angle-left" />
                                            </p>
                                        </a>
                                        <ul className="nav nav-treeview">
                                            <li className="nav-item">
                                                <a href="/manage-users" className="nav-link">
                                                    <i className="fa fa-user-plus nav-icon" />
                                                    <p>Manage Users</p>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="/user-logs" className="nav-link">
                                                    <i className="fa fa-history nav-icon" />
                                                    <p>User Logs</p>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="/login-details" className="nav-link">
                                                    <i className="fa fa-sign-in nav-icon" />
                                                    <p>Login Details</p>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="/system-config" className="nav-link">
                                                    <i className="fa fa-wrench nav-icon" />
                                                    <p>System Config</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </>
                            )}
                            
                            {/* Logout */}
                            <li className="nav-item" onClick={() => auth.signOut()}>
                                <a href="#0" className="nav-link">
                                    <i className="nav-icon fa fa-sign-out" />
                                    <p>Logout</p>
                                </a>
                            </li>

                        </ul>
                    </nav>
                </div>
            </aside>
        </div>
    );
}

export default Menu;